export default "__VITE_PUBLIC_ASSET__5ef603ed__"